export default "31fadd7e1b855430.svg"